import { render, staticRenderFns } from "./LogProposta.vue?vue&type=template&id=0fbdf3b7"
import script from "./LogProposta.vue?vue&type=script&lang=js"
export * from "./LogProposta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports